module.exports = __webpack_public_path__ + "img/2308-c2.4074ccfb.png";